<script setup lang="ts">
const config = useRuntimeConfig();
const props = defineProps<{ category: ArtworkCategory }>();

</script>
<template>
  <div class="masonry-item portfolio-item" :class="`cat-${props.category.slug}`">
    <div class="portfolio-item-content">
      <div class="item-thumbnail">
        <img :src="`${config.public.metApiBaseUrl}${props.category.image?.url}`" :alt="props.category.title" />
      </div>
      <div class="portfolio-description">
        <h4>
            <NuxtLink :to="`/artworks/${props.category.slug}`">{{ props.category.title }}</NuxtLink>
        </h4>
        <!-- <ul class="portfolio-category">
          <li><a href="#">{{ props.category.slug }}</a></li>
        </ul> -->
      </div>
    </div>
  </div>
</template>
